import type { FaireProductEntity } from "../../entity_types/product";

export const sweet_wink_17: FaireProductEntity = {
  token: "sweet-wink-17",
  type: "product",
  name: "Big Bro Short Sleeve Shirt - Pregnancy Announcement - Family",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/25a22b3c99761c852a03d89bad4b09cc41136d9fe80df3dd1be66c8c63e50a5f.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&width=720",
  priceDollars: 14,
  msrpDollars: 28,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-baby"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
